<div class="content-block top-block no-banner">
  <nav class="breadcrumb-section" aria-label="Breadcrumb">
    <div class="breadcrumb-section-left">
      <div class="content-container">
        <div class="breadcrumb">
          <ng-container>
            <div
              *ngFor="let item of items; let last = last"
              class="breadcrumb-item"
              [class.mobile-breadcrumb]="isMobile"
              [class.active]="last"
              aria-current="{{ last ? 'page' : '' }}"
            >
              <ng-container *ngIf="!last">
                <a
                  *ngIf="item.url.startsWith('/')"
                  class="breadcrumb-link"
                  [routerLink]="item.url"
                  [title]="item.label"
                >
                  <span class="breadcrumb-link-title">
                    <span class="breadcrumb-text">{{ item.label }}</span>
                  </span>
                </a>
                <a
                  *ngIf="!item.url.startsWith('/')"
                  class="breadcrumb-link"
                  [href]="item.url"
                  [title]="item.label"
                >
                  <span class="breadcrumb-link-title">
                    <span class="breadcrumb-text">{{ item.label }}</span>
                  </span>
                </a>
              </ng-container>
              <ng-container *ngIf="last">
                <span class="breadcrumb-link-title">
                  <span class="breadcrumb-text">{{ item.label }}</span>
                </span>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </nav>
</div>
